<template>
  <div :ref="chartRefId" style="width: 100%; height: 260px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'LineChartScoreTrendECharts',
  props: {
    months: {
      type: Array,
      required: true
    },
    scores: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartRefId: `score-trend-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },
  watch: {
    months() {
      this.updateChart();
    },
    scores() {
      this.updateChart();
    }
  },
  methods: {
    initChart() {
      const el = this.$refs[this.chartRefId];
      if (!el) return;

      this.chartInstance = echarts.init(el);

      this.chartInstance.setOption({
        grid: {
          left: '4%',
          right: '4%',
          top: '8%',
          bottom: '12%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: this.months,
          boundaryGap: false,
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          interval: 25,
          axisLabel: {
            formatter: '{value}%'
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: this.scores,
            smooth: false,
            symbol: 'circle',
            symbolSize: 10,
            showSymbol: false,
            lineStyle: {
              width: 0.5,
              color: '#9CA3AF'
            },
            itemStyle: {
              color: '#D97706',
              borderWidth: 3,
              borderColor: '#D97706'
            },
            areaStyle: {
              opacity: 0
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 10,
              borderWidth: 3,
              borderColor: '#D97706',
              itemStyle: { color: '#F59E0B' },
              data: [
                { coord: [0, this.scores[0]] },
                {
                  coord: [
                    this.scores.length - 1,
                    this.scores[this.scores.length - 1]
                  ]
                }
              ]
            }
          }
        ]
      });
    },
    updateChart() {
      if (!this.chartInstance) return;
      this.chartInstance.setOption({
        xAxis: {
          type: 'category',
          data: this.months,
          boundaryGap: false,
          axisTick: { show: false }
        },
        series: [
          {
            type: 'line',
            data: this.scores,
            smooth: false,
            symbol: 'circle',
            symbolSize: 10,
            showSymbol: false,
            lineStyle: {
              width: 0.5,
              color: '#9CA3AF'
            },
            itemStyle: {
              color: '#D97706',
              borderWidth: 3,
              borderColor: '#D97706'
            },
            areaStyle: {
              opacity: 0
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 10,
              borderWidth: 3,
              borderColor: '#D97706',
              itemStyle: { color: '#F59E0B' },
              data: [
                { coord: [0, this.scores[0]] },
                {
                  coord: [
                    this.scores.length - 1,
                    this.scores[this.scores.length - 1]
                  ]
                }
              ]
            }
          }
        ]
      });
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>
